import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { initDatadog } from './helpers/datadog.helper';

initDatadog();

ReactDOM.render(
    <App />,
    document.getElementById("root"));
